import { defineComponent as _defineComponent } from 'vue'
import GenericTHGUserTable from '@/components/thg/user/GenericTHGUserTable.vue';
    import { computed, onMounted, ref, watch } from 'vue';
    import { countTotalCars, exportTHGUsers, fetchTHGUsers } from '@/api/thg/users';
    import emitter from '@/utils/mitt';
    import { THGUserPaginatedResponse } from '@/interfaces/thg/THGUserPaginatedResponse';
    import THGUserFilters from '@/components/thg/user/THGUserFilters.vue';
    import { useTHGUsersStore } from '@/storenew/thg/users';
    import { alertInfo } from '@/utils/dialogs';
    import { debounce } from 'lodash';
    import THGUserActions from '@/components/thg/user/THGUserActions.vue';
    import { generate_download } from '@/utils/files';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import auth from '@/store/auth/auth';

    interface Props {
        pageSize?: number;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUserList',
  props: {
    pageSize: { default: 20 }
  },
  setup(__props: any) {

const props = __props as { pageSize: number };

    

    const data = ref<THGUserPaginatedResponse>();
    const currentPageNum = ref<number>(1);

    const isPaginated = computed<boolean>(() => {
        return Boolean(data.value?.total_results && data.value?.total_results > props.pageSize);
    });

    const { currentCountry } = useTHGGlobalStore();
    const { filterParam } = useTHGUsersStore();
    const countCarsButtonIsLoading = ref<boolean>(false);

    async function countCars() {
        countCarsButtonIsLoading.value = true;

        const resp = await countTotalCars(filterParam);
        alertInfo(
            'Info',
            `Anzahl aller Registrierungen: <strong>${resp.parsedBody?.total_cars_count}</strong>`,
        );

        countCarsButtonIsLoading.value = false;
    }

    async function doDataFetching(pageNum: number) {
        emitter.emit('showLoader');
        data.value = (await fetchUsers(pageNum)) as THGUserPaginatedResponse;
        emitter.emit('hideLoader');
    }

    async function fetchUsers(pageNum: number) {
        const { sortData } = useTHGUsersStore();

        const response = await fetchTHGUsers(
            filterParam,
            props.pageSize,
            pageNum,
            sortData.field,
            sortData.order,
        );

        const users = response.parsedBody;

        if (users) {
            return users;
        } else {
            throw new Error('Error while getting thg users.');
        }
    }

    async function onPageChange(pageNum: number) {
        currentPageNum.value = pageNum;
        await doDataFetching(currentPageNum.value);
    }

    async function onDataReloading() {
        await doDataFetching(currentPageNum.value);
    }

    async function exportCurrentData() {
        emitter.emit('showLoader');

        const { sortData } = useTHGUsersStore();
        const blobUrl = await exportTHGUsers(filterParam, sortData.field, sortData.order);

        emitter.emit('hideLoader');
        const currentDate = new Date();
        const dateStr = currentDate.toLocaleDateString().replaceAll('.', '-');
        const timeStr = currentDate.toLocaleTimeString().replaceAll(':', '');

        const filename = `Export_THG_User_${currentCountry.toUpperCase()}_${dateStr}_${timeStr}.xlsx`;

        generate_download(blobUrl, filename);
    }

    watch(
        filterParam,
        // debounce the watcher, we don't want to make requests too often when typing
        debounce(async () => {
            // filter changed: start from first page, the current page may not exist anymore
            currentPageNum.value = 1;
            await doDataFetching(currentPageNum.value);
        }, 500),
        { deep: true, immediate: false },
    );

    onMounted(async () => {
        // get initial data
        await doDataFetching(1);
    });

return { __sfc: true,props, data, currentPageNum, isPaginated, currentCountry, filterParam, countCarsButtonIsLoading, countCars, doDataFetching, fetchUsers, onPageChange, onDataReloading, exportCurrentData, GenericTHGUserTable, THGUserFilters, THGUserActions, auth }
}

})